<template>
    <div style="padding: 2rem 3rem; text-align: left;">
        <div class="field">
            <b-form-group  label="Billing Address for Data Plan Payment Line 1:" label-for="register-address-address1">
                <b-form-input 
                    id="register-address-address1"
                    v-model="model.account.line_1" 
                    type="text" 
                    required
                />
            </b-form-group>

            <b-form-group  label="Billing Address for Data Plan Payment Line 2:" label-for="register-address-address2">
                <b-form-input
                        id="register-address-address2"
                        v-model="model.account.line_2"
                        type="text"
                        required
                />
            </b-form-group>

            <b-form-group label="City:" label-for="register-address-city">
                <b-form-input 
                    id="register-address-city" 
                    v-model="model.account.city" 
                    type="text" 
                    required
                />
            </b-form-group>

            <b-form-group label="State:" label-for="register-address-state">
                <b-form-select 
                    v-model="model.account.state" 
                    :options="stateOptions" 
                    id="register-address-state"
                    required
                />
            </b-form-group>

            <b-form-group label="Zip Code:" label-for="register-address-zip" >
                <b-form-input 
                    id="register-address-zip" 
                    v-model="model.account.zip_code" 
                    type="text" 
                    required
                />
            </b-form-group>
        </div>
    </div>
</template>

<script>

    import { stateOptions } from '../../helpers/address'
    export default {
        props: {
            model:{ type: Object }
        },

        data(){
            return{
                stateOptions: stateOptions
            }
        },

        mounted(){ this.$emit('can-continue', {value: true}) }
    }

</script>
